import { useParams } from 'react-router-dom';
import { SessionAttendanceView } from '@/views/SessionAttendanceView';
import { MainLayout } from '@/widgets/layouts/MainLayout';

const SessionAttendancePage = () => {
  const { courseId, intakeId, groupNumber, termId, moduleId, groupLessonId } = useParams<{
    courseId: string;
    intakeId: string;
    groupNumber: string;
    termId: string;
    moduleId: string;
    groupLessonId: string;
  }>();

  if (!courseId || !intakeId || !groupNumber || !termId || !moduleId || !groupLessonId) {
    return null;
  }

  return (
    <MainLayout headerTitle="Session Attendance">
      <SessionAttendanceView
        courseId={Number(courseId)}
        intakeId={Number(intakeId)}
        groupNumber={Number(groupNumber)}
        termId={Number(termId)}
        moduleId={Number(moduleId)}
        groupLessonId={Number(groupLessonId)}
      />
    </MainLayout>
  );
};

export default SessionAttendancePage;
